import React from 'react';
import { FaWindows, FaApple, FaLinux } from 'react-icons/fa';
import { ButtonContainer } from './button-container.component';
export const FileSelect = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-[10px]">
    <ButtonContainer os="windows" label="Windows">
      <FaWindows size={18} color="var(--color-text-muted-alt)" />
    </ButtonContainer>
    <ButtonContainer os="mac" label="macOS">
      <FaApple size={18} color="var(--color-text-muted-alt)" />
    </ButtonContainer>
    <ButtonContainer os="linux" label="Linux">
      <FaLinux size={18} color="var(--color-text-muted-alt)" />
    </ButtonContainer>
  </div>
);
